'use client'
import React, { useEffect, useState } from "react";
import { ApiClient } from "../../utils/apiclient";
import PageControl from "../../components/page_control";
import SearchBox from "../../components/search_box";
import { USERS_HEADINGS } from "../../utils/constants";
import TableHeader from "../../components/table_header";


const UserListItem = (props: any) => {
  const [activeUsers, setActiveUsers] = useState<any[]>([])
  const [filteredUsers, setFilteredUsers] = useState(activeUsers)
  const [pageInfo, setPageInfo] = useState<any>({ totalPages: 0, totalCount: 0, currentPage: 1, pageSize: 15, hasNext: false, hasPrevious: false });
  const [pageSize, setPageSize] = useState<number>(20)
  const [page, setPage] = useState<number>(1)
  //   const handleClick = (e,r) => {
  //     props.onClick(r);
  //   };
  const getPreviousPage = () => {
    setPage(page - 1)
  }
  const getNextPage = () => {
    setPage(page + 1);
  }
  const getUsers = async (pageSize: number, page: number) => {
    const apiClient = new ApiClient();
    const response = await apiClient.getUsers({ page: page, take: pageSize });
    if (response.status == 200) {
      const data = response.data;
      setPageInfo({ totalPages: response.data.totalPages, totalCount: response.data.totalCount, currentPage: response.data.page, pageSize: response.data.pageSize, hasNext: response.data.hasNext, hasPrevious: response.data.hasPrevious })

      setActiveUsers(data.users);
      setFilteredUsers(data.users);
    }
  }

  const handlePageSizeChange = (pageSize: number) => {
    if (pageSize && pageSize >= 10) {
      setPageSize(pageSize);
      setPage(1)
    }
    else {
      setPageSize(10);
      setPage(1);
    }
  }

  const handleFilter = (keyword: string) => {
    const result = activeUsers.filter((user) => user?.username.toLowerCase().includes(keyword.toLowerCase()) 
    || user?.position_detail?.value.toLowerCase().includes(keyword.toLowerCase()) 
    || user?.region.toLowerCase().includes(keyword.toLowerCase()) 
    || user?.email.toLowerCase().includes(keyword.toLowerCase()) 
    || user?.phone.toLowerCase().includes(keyword.toLowerCase()) 
    || user?.location.toLowerCase().includes(keyword.toLowerCase()) 
    || user?.dept_code?.toLowerCase().includes(keyword.toLowerCase())  );
    setFilteredUsers(result);
  }
  useEffect(() => {
    getUsers(pageSize, page)
  }, [pageSize, page])

  return (
    <div className="w-full text-textDefault mt-4">
      <div className="w-full flex items-center justify-between pt-4">
        <p className="text-2xl font-bold">Users</p>
        <SearchBox onChange={handleFilter} /></div>
        <div className="w-full border-top flex-row flex-start bg-main-color align-items-center ">
        <PageControl pageSize={pageSize} onNext={getNextPage} onPrevious={getPreviousPage} currentPage={page} totalPages={pageInfo.totalPages} onPageSizeChange={(pageSize: number) => { handlePageSizeChange(pageSize) }} hasNext={pageInfo.hasNext} hasPrevious={pageInfo.hasPrevious} />

      </div>
      <table className="w-full text-left p-2 mx-auto border">
        <TableHeader data={USERS_HEADINGS} />
        <tbody className="w-full text-sm">
          {filteredUsers.map(row => {
            return (
              <tr key={row.id} className="mt-2 border-b border-b-gray-200 py-4 hover:bg-primaryLight cursor-pointer">
                <td className="border-bottom px-1">{row.username}
                </td>
                <td className="border-bottom px-1">{row.email}
                </td>
                <td className="border-bottom px-1">{row.phone}
                </td>
                <td className="border-bottom px-1">{`${row.fname} ${row.lname}`}
                </td>
                <td className="border-bottom px-1">{row.position_detail.value}
                </td>
                <td className="border-bottom px-1">{row.dept_code}
                </td>
                <td className="border-bottom px-1">{row.location}
                </td>
                <td className="border-bottom px-1">{row.busy == 0 ? 'Available' : 'Busy'}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      

    </div>)

};
export default UserListItem;
